module.exports = __webpack_public_path__ + "static/img/pro2-1.38eb408.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/zh/pro2-1.png
// module id = Gt/R
// module chunks = 0